import { useQuery } from "@apollo/client";
import { IMillDetailEntity } from "./MillDetailInterfaces";
import { getCorporateZipcodeAndCountry } from "api/queries/MillsAPI";

export const MillDetailEntity: IMillDetailEntity = {
    GetCorporateZipcodeAndCountry: (mill_id) => {
        const { loading, error, data } = useQuery(getCorporateZipcodeAndCountry, {
            variables: {
                mill_id,
            },
        });
        let zipCode = "";
        let countryCode = "";
        let timezone = "";
        if (data) {
            zipCode = data.corporate[0]?.zip_code;
            countryCode = data.corporate[0]?.country?.code;
            timezone = data.mill[0]?.mill_data?.timezone;
        }

        return {
            loading,
            zipCode,
            countryCode,
            timezone,
            apolloQueryError: error,
        };
    },
};
